export const abrirPopup = (url: string): void => {
  const popup = window.open(url, '_blank');

  if (!popup || popup.closed || typeof popup.closed === 'undefined') {
    alert(
      'O navegador bloqueou a janela do cupom.\n\n' +
        '🔒 Isso geralmente acontece por segurança. Para resolver:\n\n' +
        '👉 Procure por um ícone de aviso ou bloqueio na barra de endereço do navegador (geralmente no canto direito ou esquerdo).\n' +
        '🖱️ Clique nele e permita a abertura de janelas pop-up para este site.\n' +
        '🔄 Em seguida, tente novamente.',
    );
  }
};
